// Match Payer::EMAIL_FORMAT to reject formats such as na@na.
// This is a local format check; Stripe's server-side validation remains authoritative.
// https://docs.stripe.com/error-codes#email-invalid
export const isValidEmail = (value: string): boolean =>
  /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)+$/.test(
    value.trim(),
  );
